export type RatingOptOut = {
  orderId: number;
  email: string;
};

export enum OptoutTypes {
  RATING = "rating",
}
